module.exports = __webpack_public_path__ + "img/layout_bottom_6.34d816c9.png";